import {
  type CreateStandalonePatientVisitRequest,
  type CreateStandalonePatientVisitResponse,
  useCreateStandalonePatientVisit as useSharedCreateStandalonePatientVisit,
  useVideaNotesApi,
} from '@repo/videa-notes';
import { useQueryClient } from '@tanstack/react-query';

import { endpoints } from '@/react-query/endpoints';

export const useCreateStandalonePatientVisit = () => {
  const { getContext } = useVideaNotesApi();
  const queryClient = useQueryClient();
  const { practiceId } = getContext();

  return useSharedCreateStandalonePatientVisit({
    onSuccess: () => {
      queryClient.invalidateQueries([
        endpoints.ambient.standalonePatientVisits,
        practiceId,
      ]);
      queryClient.invalidateQueries([
        endpoints.ambient.voiceNotes.combinedAppointmentsList,
      ]);
    },
  });
};

export type {
  CreateStandalonePatientVisitRequest,
  CreateStandalonePatientVisitResponse,
};
